export default {
	init() {
		//console.log('Nylon home');
	},
	finalize() {},
};
